import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=4b4a8fab"
import script from "./GamesList.vue?vue&type=script&lang=ts"
export * from "./GamesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports